<div class="card">
  <div class="card-header compact">
    <h1 test-id="project-label" class="ellipsis">{{ project.label || ('projectInfo.noLabel' | translate) }}</h1>
    <div class="card-actions">
      <app-button-group class="compact fill-white">
        <button *ngIf="permissions.editMetadata" test-id="save-button" type="button" mat-flat-button color="accent" (click)="saveChanges()">
          Save
        </button>
        <button *ngIf="permissions.editMetadata" test-id="reset-button" type="button" mat-stroked-button (click)="resetForm()">
          Reset
        </button>
      </app-button-group>
    </div>
  </div>
  <form>
    <div class="info-row">
      <mat-icon *ngIf="permissions.editMetadata"
        test-id="project-change-help"
        [matTooltip]="'projectInfo.projectChangeTooltip' | translate"
        class="field-tooltip xs">info</mat-icon>
      <span *ngIf="!permissions.editMetadata" class="field-tooltip"></span>
      <span class="field-label">{{ 'common.labels.project' | translate }}</span>
      <div class="field-value">
        <span *ngIf="!permissions.editMetadata">{{ project.label }}</span>
        <mat-select *ngIf="permissions.editMetadata" test-id="project-select" [formControl]="projectId">
          <mat-optgroup *ngFor="let group of groupedProjects$ | async" [label]="groupLabel(group)">
            <mat-option *ngFor="let project of group.projects" [value]="project._id">
              {{ project.label || project._id }}
            </mat-option>
          </mat-optgroup>
        </mat-select>
      </div>
      <div class="field-error"></div>
    </div>
    <div class="info-row">
      <span class="field-tooltip"></span>
      <span class="field-label">{{ 'common.labels.group' | translate }}</span>
      <div class="field-value">
        <span test-id="group-label">{{ groupLabel(group) }}</span>
      </div>
      <div class="field-error"></div>
    </div>
    <div class="info-row">
      <span class="field-tooltip"></span>
      <span class="field-label">{{ 'common.labels.sessions' | translate }}</span>
      <div class="field-value">
        <span test-id="session-count">{{ projectStats?.session_count }}</span>
      </div>
      <div class="field-error"></div>
    </div>
    <div class="info-row">
      <span class="field-tooltip"></span>
      <a test-id="view-project-button" mat-flat-button [routerLink]="projectHref" color="primary">
        {{ 'projectInfo.viewProject' | translate }}
      </a>
    </div>
  </form>
</div>
